module.exports = __webpack_public_path__ + "static/media/2.92fb17ec.jpg";